export enum ReportViewModes {
  PartnerView = 1,
  QuarterlyView = 2,
  TrendView = 3,
}
